// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"85de4687","226":"07235da3","435":"58bcb5cf","697":"0fb69b16","701":"73224057","827":"d72dcf5f","974":"552af1a1"}[chunkId] + ".chunk.js";
};